<template>
  <div class="customer-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">客户管理</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="selectedIds.length === 0" @click="handleDelete">删除</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">导入客户</el-button>
        <el-button type="warning" :disabled="selectedIds.length === 0" @click="openBatchAssignment">批量分配</el-button>
        <el-button type="info" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-bar">
      <el-input v-model="queryParams.userInfo" placeholder="用户信息" clearable style="width: 150px" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.contact" placeholder="联系方式" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.cityRemark" placeholder="城市备注" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.leadPath" placeholder="留资路径" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-select
        v-model="queryParams.assignedUserId"
        placeholder="分配员工"
        clearable
        filterable
        style="width: 180px; margin-left: 10px;"
        @visible-change="loadAssignableUsers"
      >
        <el-option
          v-for="user in assignableUserOptions"
          :key="user.id"
          :label="`${user.userName}(${user.nickName})`"
          :value="user.id"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleQuery" style="margin-left: 10px;">搜索</el-button>
      <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="loading"
      :data="customerList"
      @selection-change="handleSelectionChange"
      row-key="id"
      stripe
      :max-height="tableMaxHeight"
    >
      <el-table-column type="selection" width="50" align="center" />
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ getRowIndex(scope.$index) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" width="160">
        <template slot-scope="scope">
          <div class="cell-with-image">
            <el-image
              v-if="scope.row.ocrImageUrl"
              :src="scope.row.ocrImageUrl"
              fit="cover"
              class="table-image"
              :preview-src-list="[scope.row.ocrImageUrl]"
            />
            <el-image
              v-if="scope.row.customerImageUrl"
              :src="scope.row.customerImageUrl"
              fit="cover"
              class="table-image"
              :preview-src-list="[scope.row.customerImageUrl]"
            />
            <span>{{ formatDate(scope.row.createTime) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户信息" align="center" prop="userInfo" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="联系方式" align="center" prop="contact" width="130" />
      <el-table-column label="城市备注" align="center" prop="cityRemark" min-width="100" :show-overflow-tooltip="true" />
      <el-table-column label="留资路径" align="center" prop="leadPath" min-width="100" :show-overflow-tooltip="true" />
      <el-table-column label="特征标签" align="center" prop="featureTags" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="备注" align="center" prop="remark" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="已分配员工" align="center" prop="assignUserNames" min-width="150" :show-overflow-tooltip="true" />
      <el-table-column label="操作" width="320">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openAssignment(scope.row)">分配员工</el-button>
          <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button type="text" size="small" class="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <span class="total-text">共 {{ total }} 条记录</span>
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="queryParams.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>

    <!-- 新增/修改对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px" append-to-body>
      <el-form ref="customerFormRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户信息" prop="userInfo">
          <el-input v-model="form.userInfo" placeholder="请输入用户信息" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="城市备注" prop="cityRemark">
          <el-input v-model="form.cityRemark" placeholder="请输入城市备注" />
        </el-form-item>
        <el-form-item label="留资路径" prop="leadPath">
          <el-input v-model="form.leadPath" placeholder="请输入留资路径" />
        </el-form-item>
        <el-form-item label="特征标签" prop="featureTags">
          <el-input v-model="form.featureTags" placeholder="请输入特征标签" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="客户图片" prop="customerImageUrl">
          <div class="image-upload" @click="triggerImageUpload" v-if="!form.customerImageUrl">
            <i class="el-icon-plus"></i>
            <span>上传图片</span>
          </div>
          <div v-else class="image-preview-wrapper">
            <el-image
              :src="form.customerImageUrl"
              fit="cover"
              class="upload-preview"
              :preview-src-list="[form.customerImageUrl]"
            />
            <div class="image-actions">
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click.stop="removeFormImage"></el-button>
            </div>
          </div>
          <input type="file" ref="imageInput" accept="image/*" style="display: none" @change="handleImageChange" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配员工对话框 -->
    <el-dialog title="分配员工" :visible.sync="assignmentDialog.visible" width="600px" append-to-body>
      <div class="assignment-search">
        <el-select
          v-model="assignmentDialog.tempUserId"
          filterable
          clearable
          remote
          placeholder="搜索用户名/昵称"
          style="width: 100%"
          :remote-method="loadSearchResults"
          :loading="assignmentDialog.loading"
          @visible-change="handleUserDropdownChange"
        >
          <el-option
            v-for="item in assignmentDialog.searchResults"
            :key="item.id"
            :label="`${item.userName}(${item.nickName})`"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-table :data="assignmentDialog.list" max-height="350" border style="margin-top: 12px">
        <el-table-column label="用户名" align="center" prop="userName" />
        <el-table-column label="用户昵称" align="center" prop="nickName" />
        <el-table-column label="操作" align="center" width="320">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="handleUnassignUser(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignmentDialog.visible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 批量分配员工对话框 -->
    <el-dialog title="批量分配员工" :visible.sync="batchDialog.visible" width="900px" append-to-body>
      <el-table :data="batchDialog.items" max-height="400" border>
        <el-table-column label="用户信息" min-width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.userInfo || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" min-width="130" align="center" prop="contact" />
        <el-table-column label="添加员工" min-width="180" align="center">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.tempUserId"
              filterable
              remote
              clearable
              placeholder="搜索用户"
              style="width: 100%"
              :remote-method="(kw) => loadBatchSearchResults(scope.$index, kw)"
              :loading="scope.row.loading"
              @visible-change="(v) => v && loadBatchSearchResults(scope.$index, '')"
            >
              <el-option
                v-for="item in scope.row.searchResults || []"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="已分配员工" min-width="200" align="center">
          <template slot-scope="scope">
            {{ scope.row.assignUserNames || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog.visible = false">关 闭</el-button>
        <el-button type="primary" @click="submitBatchAssignment">确认分配</el-button>
      </div>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog title="导入客户" :visible.sync="importDialog.visible" width="500px" append-to-body>
      <div class="import-content">
        <el-upload
          ref="importUpload"
          :limit="1"
          accept=".xlsx,.xls"
          :auto-upload="false"
          :on-change="handleImportFileChange"
          :file-list="importDialog.fileList"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            <el-link type="primary" @click="downloadTemplate">下载模板</el-link>
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialog.visible = false">取 消</el-button>
        <el-button type="primary" :loading="importDialog.loading" @click="submitImport">确定导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerList,
  getCustomerById,
  addCustomer,
  updateCustomer,
  deleteCustomer,
  importCustomers,
  importOcrCustomers,
  importCustomerData,
  getCustomerAssignments,
  assignUserToCustomer,
  unassignUserFromCustomer,
  getAssignableUsers,
  searchUsers,
  batchAssignUsers,
  uploadFile
} from '@/api/customerApi'

export default {
  name: 'CustomerManage',
  data() {
    return {
      loading: false,
      customerList: [],
      selectedIds: [],
      selectedRows: [],
      total: 0,
      tableMaxHeight: window.innerHeight - 280,
      assignableUserOptions: [],
      queryParams: {
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        assignedUserId: null,
        pageNum: 1,
        pageSize: 10
      },
      dialog: {
        title: '新增客户',
        visible: false
      },
      form: {
        id: null,
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        remark: '',
        customerImageUrl: ''
      },
      rules: {
        contact: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        userInfo: [{ required: true, message: '请输入用户信息', trigger: 'blur' }]
      },
      assignmentDialog: {
        visible: false,
        customerId: null,
        tempUserId: null,
        list: [],
        searchResults: [],
        loading: false
      },
      batchDialog: {
        visible: false,
        items: [],
        loading: false
      },
      importDialog: {
        visible: false,
        fileList: [],
        loading: false,
        importData: null
      }
    }
  },
  mounted() {
    this.getList()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.tableMaxHeight = window.innerHeight - 280
    },
    async getList() {
      this.loading = true
      try {
        const res = await getCustomerList(this.queryParams)
        this.customerList = res.list || []
        this.total = res.total || 0
      } catch (e) {
        console.error('加载客户列表失败', e)
        this.$message.error('加载客户列表失败')
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        assignedUserId: null,
        pageNum: 1,
        pageSize: this.queryParams.pageSize
      }
      this.getList()
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
      this.selectedRows = selection
    },
    handlePageChange(page) {
      this.queryParams.pageNum = page
      this.getList()
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.getList()
    },
    getRowIndex(index) {
      return (this.queryParams.pageNum - 1) * this.queryParams.pageSize + index + 1
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    goBack() {
      this.$router.push('/home/workbench')
    },
    handleAdd() {
      this.resetForm()
      this.dialog.title = '新增客户'
      this.dialog.visible = true
    },
    async handleUpdate(row) {
      try {
        const res = await getCustomerById(row.id)
        this.form = { ...res }
        this.dialog.title = '修改客户'
        this.dialog.visible = true
      } catch (e) {
        this.$message.error('获取客户详情失败')
      }
    },
    async submitForm() {
      try {
        await this.$refs.customerFormRef.validate()
        if (this.form.id) {
          await updateCustomer(this.form)
          this.$message.success('修改成功')
        } else {
          await addCustomer(this.form)
          this.$message.success('新增成功')
        }
        this.dialog.visible = false
        this.getList()
      } catch (e) {
        if (e !== false) {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleDelete(row) {
      const ids = row.id ? [row.id] : this.selectedIds
      if (ids.length === 0) {
        this.$message.warning('请选择要删除的客户')
        return
      }
      try {
        await this.$confirm('确定要删除选中的客户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteCustomer(ids)
        this.$message.success('删除成功')
        this.getList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    resetForm() {
      this.form = {
        id: null,
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        remark: '',
        customerImageUrl: ''
      }
      if (this.$refs.customerFormRef) {
        this.$refs.customerFormRef.clearValidate()
      }
    },
    triggerImageUpload() {
      this.$refs.imageInput.click()
    },
    async handleImageChange(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData)
        this.form.customerImageUrl = res.url || res
        this.$message.success('图片上传成功')
      } catch (e) {
        this.$message.error('图片上传失败')
      }
      e.target.value = ''
    },
    removeFormImage() {
      this.form.customerImageUrl = ''
    },
    async openAssignment(row) {
      this.assignmentDialog.customerId = row.id
      this.assignmentDialog.list = []
      this.assignmentDialog.tempUserId = null
      this.assignmentDialog.searchResults = []
      try {
        const res = await getCustomerAssignments(row.id)
        this.assignmentDialog.list = res || []
      } catch (e) {
        console.error('加载分配列表失败', e)
      }
      this.assignmentDialog.visible = true
    },
    async handleUserDropdownChange(visible) {
      if (visible) {
        await this.loadSearchResults('')
      }
    },
    async loadSearchResults(keyword) {
      this.assignmentDialog.loading = true
      try {
        const res = await getAssignableUsers(keyword)
        const excludeIds = this.assignmentDialog.list.map(item => item.userId)
        this.assignmentDialog.searchResults = (res || []).filter(item => !excludeIds.includes(item.id))
      } catch (e) {
        console.error('搜索用户失败', e)
      } finally {
        this.assignmentDialog.loading = false
      }
    },
    async loadAssignableUsers(visible) {
      if (visible && this.assignableUserOptions.length === 0) {
        try {
          const res = await getAssignableUsers('')
          this.assignableUserOptions = res || []
        } catch (e) {
          console.error('加载用户列表失败', e)
        }
      }
    },
    async confirmAssignmentUser(userId) {
      if (!userId) return
      try {
        await assignUserToCustomer(this.assignmentDialog.customerId, userId)
        this.$message.success('分配成功')
        const res = await getCustomerAssignments(this.assignmentDialog.customerId)
        this.assignmentDialog.list = res || []
        this.assignmentDialog.tempUserId = null
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '分配失败')
      }
    },
    async handleUnassignUser(row) {
      try {
        await this.$confirm('确定要取消该员工的分配吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await unassignUserFromCustomer(this.assignmentDialog.customerId, row.userId)
        this.$message.success('取消分配成功')
        const res = await getCustomerAssignments(this.assignmentDialog.customerId)
        this.assignmentDialog.list = res || []
        this.getList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '取消分配失败')
        }
      }
    },
    openBatchAssignment() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择客户')
        return
      }
      this.batchDialog.items = this.selectedRows.map(row => ({
        ...row,
        tempUserId: null,
        searchResults: [],
        loading: false
      }))
      this.batchDialog.visible = true
    },
    async loadBatchSearchResults(index, keyword) {
      const item = this.batchDialog.items[index]
      if (!item) return
      item.loading = true
      try {
        const res = await getAssignableUsers(keyword)
        item.searchResults = (res || []).map(u => ({
          value: u.id,
          label: `${u.userName}(${u.nickName})`
        }))
      } catch (e) {
        console.error('搜索用户失败', e)
      } finally {
        item.loading = false
      }
    },
    async submitBatchAssignment() {
      const assignments = []
      for (const item of this.batchDialog.items) {
        if (item.tempUserId) {
          assignments.push({
            customerId: item.id,
            userId: item.tempUserId
          })
        }
      }
      if (assignments.length === 0) {
        this.$message.warning('请至少选择一个分配')
        return
      }
      try {
        for (const assignment of assignments) {
          await assignUserToCustomer(assignment.customerId, assignment.userId)
        }
        this.$message.success('批量分配成功')
        this.batchDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '批量分配失败')
      }
    },
    handleImport() {
      this.importDialog.visible = true
      this.importDialog.fileList = []
    },
    handleImportFileChange(file, fileList) {
      this.importDialog.fileList = fileList.slice(-1)
      this.importDialog.importData = file.raw
    },
    downloadTemplate() {
      window.open('/customer/importTemplate', '_blank')
    },
    async submitImport() {
      if (!this.importDialog.importData) {
        this.$message.warning('请选择要导入的文件')
        return
      }
      this.importDialog.loading = true
      try {
        const formData = new FormData()
        formData.append('file', this.importDialog.importData)
        await this.$http.post('/customer/importData', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        this.$message.success('导入成功')
        this.importDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '导入失败')
      } finally {
        this.importDialog.loading = false
      }
    },
    async handleExport() {
      if (this.customerList.length === 0) {
        this.$message.warning('没有可导出的数据')
        return
      }
      try {
        this.$message.info('正在导出...')
        const params = { ...this.queryParams, pageNum: 1, pageSize: 10000 }
        const res = await getCustomerList(params)
        const data = res.list || []
        
        // 构建CSV内容
        const headers = ['用户信息', '联系方式', '城市备注', '留资路径', '特征标签', '备注', '已分配员工', '创建时间']
        const rows = data.map(item => [
          item.userInfo || '',
          item.contact || '',
          item.cityRemark || '',
          item.leadPath || '',
          item.featureTags || '',
          item.remark || '',
          item.assignUserNames || '',
          this.formatDate(item.createTime)
        ])
        
        const csvContent = [headers, ...rows]
          .map(row => row.map(cell => `"${(cell || '').toString().replace(/"/g, '""')}"`).join(','))
          .join('\n')
        
        const BOM = '\uFEFF'
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `客户资料_${new Date().toLocaleDateString()}.csv`
        link.click()
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style scoped>
.customer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  overflow: auto;
}

.page-header {
  background: #fff;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 15px 20px;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
}

.el-table {
  background: #fff;
  border-radius: 4px;
}

.cell-with-image {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-image {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 15px;
}

.total-text {
  font-size: 14px;
  color: #606266;
}

.image-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
}

.image-upload i {
  font-size: 28px;
  margin-bottom: 4px;
}

.image-upload span {
  font-size: 12px;
}

.image-preview-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
}

.upload-preview {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}

.image-actions {
  position: absolute;
  top: -8px;
  right: -8px;
}

.assignment-search {
  margin-bottom: 0;
}

.import-content {
  padding: 20px;
}

.import-content >>> .el-upload {
  width: 100%;
}

.import-content >>> .el-upload-dragger {
  width: 100%;
  height: 200px;
}

.danger {
  color: #f56c6c;
}
</style>
